import { parse } from 'date-fns';

const shortCalendarDateFormat = 'yyyy-LL';

const fullCalendarDateFormat = 'yyyy-LL-dd';

export const normalizeM8DateString = (serverDate: string) => ({
  toDate() {
    if (shortCalendarDateFormat.length === serverDate.length) {
      return parse(serverDate, shortCalendarDateFormat, new Date());
    }

    if (fullCalendarDateFormat.length === serverDate.length) {
      return parse(serverDate, fullCalendarDateFormat, new Date());
    }

    return new Date(serverDate);
  },
});
